export default [
  { key: 0, value: "جدیدترین", type:"outline" },
  { key: 1, value: "خوانده نشده", type:"outline"},
  { key: 2, value: "بر اساس موضوع", type:"outline" }
]